import { StateService } from "@uirouter/angular";
import { BACKSPACE, ENTER, SPACE } from "@angular/cdk/keycodes";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { USER_ROLES_VIEWONLY } from "@gtmhub/shared/utils/user-roles";
import { CurrentUserService } from "@gtmhub/users";
import { AnalyticsService } from "@webapp/analytics/services/analytics.service";
import { Link, LinkSpecDetail, RelatedLink } from "@webapp/links/models/links.models";
import { IRelatedItem, IUpdateLinkArgs } from "@webapp/links/models/related-items.models";
import { RelationshipOptionsButtonComponent } from "../relationship-options-button/relationship-options-button.component";

enum LocalizationKey {
  GOAl = "objective",
  METRIC = "key_result",
}

@Component({
  selector: "related-item-row",
  templateUrl: "./related-item-row.component.html",
  styleUrls: ["./related-item-row.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemRowComponent implements OnInit {
  @Input() public relatedItem: IRelatedItem;
  @Output() public readonly deleteRelatedItem = new EventEmitter<IRelatedItem>();
  @Output() public readonly updateLinkOption = new EventEmitter<IUpdateLinkArgs>();

  @ViewChild(RelationshipOptionsButtonComponent) public relationshipButton: RelationshipOptionsButtonComponent;
  @ViewChild("rowInfo", { read: ElementRef<HTMLElement> }) public rowInfo: ElementRef<HTMLElement>;

  public hasViewOnlyRole: boolean;
  public tooltipTitle: string;
  private linkTypeToDelete: Link;

  constructor(private stateService: StateService, private currentUserService: CurrentUserService, private analyticsService: AnalyticsService) {}

  public ngOnInit(): void {
    this.linkTypeToDelete = this.relatedItem.linkType;

    if (this.relatedItem.linkType === "related") {
      this.relatedItem.linkType = "relating";
    }

    this.hasViewOnlyRole = this.currentUserService.userHasRole(USER_ROLES_VIEWONLY);
    this.tooltipTitle = this.relatedItem.iconType === "goal" ? LocalizationKey.GOAl : LocalizationKey.METRIC;
  }

  public onUpdateLinkOption(update: RelatedLink): void {
    this.relatedItem.linkType = update;
    const args: IUpdateLinkArgs = { linkTypeToDelete: this.linkTypeToDelete, relatedItem: this.relatedItem };
    this.updateLinkOption.emit(args);
    this.linkTypeToDelete = this.relatedItem.linkType;
  }

  public onDeleteItem(): void {
    this.relatedItem.linkType = this.linkTypeToDelete;
    this.deleteRelatedItem.emit(this.relatedItem);
  }

  public openRelatedItem(relatedItem: IRelatedItem): void {
    this.analyticsService.track("Related item clicked");
    const type: LinkSpecDetail = relatedItem.iconType;
    if (type === "goal") {
      this.stateService.go("gtmhub.goals.all._goalSidebar.goal", { id: relatedItem.id });
    } else {
      this.stateService.go("gtmhub.goals.all._metric.metric", { metricId: relatedItem.id });
    }
  }

  public onKeydown(evt: KeyboardEvent): void {
    switch (evt.keyCode) {
      case BACKSPACE:
        this.onDeleteItem();
        break;
      case ENTER:
      case SPACE:
        this.openRelatedItem(this.relatedItem);
        break;
    }
  }
}
